import FormData from 'form-data';
import isEmpty  from 'lodash/isEmpty';

export class FormHandler {

  constructor({ multiForm = false }) {
    this.images = [];
    this.files = [];
    this.additionalImageData = {};
    this.formData = {};
    this.multiForm = multiForm;

  }

  b64toBlob(b64Data, contentType='', sliceSize=512) {
    if(b64Data.indexOf(",") >= 0)
    {
      b64Data = b64Data.substring(b64Data.indexOf(",") + 1);
    }
    const byteCharacters = window.atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, {type: contentType});
  }

  add(key, value, override = false) {
    if (override || !this.formData.hasOwnProperty(key)) {
      return this.set(key, value);
    }

    const type = typeof this.formData[key];
    switch (type.toLowerCase()) {
      case 'string'  :
      case 'number'  :
      case 'boolean' :
        return this.set(key, value);

      case 'object' :
        if (Array.isArray(this.formData[key])) {
          this.formData[key].push(value);
          return this;
        }
        return this.set(key, value);

      default :
        return this.set(key, value);

    }
  }

  addImage(image, key = 'images') {
    if (typeof image !== 'object') {
      console.error('the given image is not an valid image Object');
      return this;
    }

    this.additionalImageData[image.uid] = {
      id: image.id || null,
      uid: image.uid,
      name: image.name,
      size: image.size,
      sorting: image.sorting,
      mimetype: image.type,
      aspect: image.aspect || 1,
      _delete: image._delete ?? false,
      _update: !image._delete && !image.id.match(/^new_/i) ? true : false,
    };

    if (image.status && image.status === 'updated') {
      this.additionalImageData[image.uid].id = image.id;
      this.additionalImageData[image.uid].update = true;

      return this;
    }

    this.images.push({ key, image });

    return this;
  }

  addFile(file, key = 'files') {
    if (typeof file !== 'object') {
      console.error('the given file is not an valid file Object');
      return this;
    }
    this.files.push({ key, file });

    return this;
  }

  addImages(images, key = 'images') {
    if (!Array.isArray(images)) {
      console.warn('images are not an array');
      return this.addImage(images, key);
    }

    images.forEach(image => this.addImage(image, key));

    return this;
  }

  addFiles(files, key = 'files') {
    if (!Array.isArray(files)) {
      console.warn('files are not an array');
      return this.addImage(files, key);
    }

    files.forEach(file => this.addFile(file, key));

    return this;
  }

  set(key, value) {
    this.formData[key] = value;
    return this;
  }

  get(key) {
    if (this.has(key)) {
      return this.formData[key];
    }
    return null;
  }

  has(key) {
    return this.formData.hasOwnProperty(key);
  }


  parseData(formDataName = 'data') {
    if(!this.multiForm) {
      return this.formData;
    }
    const form = new FormData();

    if (this.images.length > 0) {
      this.set('_additionalImageData', this.additionalImageData);
    }
    if (!isEmpty(this.additionalImageData)) {
      this.set('_additionalImageData', this.additionalImageData);
    }

    form.append(formDataName, JSON.stringify(this.formData));

    if (this.images.length > 0) {
      this.images.filter(({ image }) => !!`${image?.id}`.match(/^new/)).forEach(({ key, image }) => form.append(key, this.b64toBlob(image.url), image.uid));
    }
    if (this.files.length > 0) {
      this.files.forEach(({ key, file }) => form.append(`${key}`, (file.originFileObj) ? file.originFileObj : file, file.name));
    }


    return form;
  }

  reset() {
    this.images = [];
    this.additionalImageData = {};
    this.formData = {};
  }


}
